//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        item: {
            type: Object,
            default: () => {
                return {}
            }
        },
        answered: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    methods: {
        selectAnswer (index) {
            const { question, answers } = this.item
            const { answer, id } = answers[index] || {}
            this.$emit('getQuestion', id, {
                id,
                question,
                answer
            })
        }
    }
}
